import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonCommon: {
    id: "error.button.common",
    defaultMessage: "Обновить",
  },
  buttonHome: {
    id: "error.button.home",
    defaultMessage: "На главный экран",
  },
  buttonRefresh: {
    id: "error.button.refresh",
    defaultMessage: "Обновить",
  },
  subtitleCommon: {
    id: "error.subtitle.common",
    defaultMessage: "Попробуйте обновить страницу",
  },
  subtitleNotFound: {
    id: "error.subtitle.notFound",
    defaultMessage:
      "Похоже, эта страница сейчас недоступна или ее больше не существует",
  },
  subtitleUnexpected: {
    id: "error.subtitle.unexpected",
    defaultMessage: "Попробуйте обновить страницу",
  },
  titleCommon: {
    id: "error.title.common",
    defaultMessage: "Не удалось загрузить данные",
  },
  titleNotFound: {
    id: "error.title.notFound",
    defaultMessage: "Раздел не найден",
  },
  titleUnexpected: {
    id: "error.title.unexpected",
    defaultMessage: "Не удалось загрузить данные",
  },
});
